export default __webpack_public_path__ + "static/vanilla-c8d03f8e0b002a136593264ffe75aaed.png";